import React, { Component } from "react";
import ReadAxios from "../axiosComponent/read";
import MiniPlaceholder from "./miniPlaceHolder";
import { Grid } from "semantic-ui-react";
import isEmpty from "lodash/isEmpty";
import { FEATURES } from "../../utils/constant";

export class RouteManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routes: [],
    };
  }

  async componentDidMount() {
    console.log('route component called');
    let dataArray =
      (await ReadAxios({
        url: `routeManager/${this.props.routeId}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ routes: dataArray || [] });
  }

  async componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      let dataArray =
        (await ReadAxios({
          url: `routeManager/${this.props.routeId}`,
        })) || [];
      dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
      this.setState({ routes: dataArray || [] });
    }
  }

  render() {
    const { routes } = this.state;
    return routes.length > 0 ? (
      <>
        <div style={{ marginBottom: "3em" }}>
          <Grid.Column width={1} style={{ position: "absolute", left: "0" }}>
            <img src="assets/svg/navigation.svg" alt={""} width="20" /><br></br>
            <small>
              {/* {routes[0].budgetedKms || 0} {" Kms"} */}
              {/* {this.props.km} {" Kms"} */}
              {routes[0].budgetedKms}{" Kms"}
            </small><br></br>
            <span className="p-bold-600 movement_type w3-text-blue">{this.props.movement}</span>
          </Grid.Column>
          <div style={{ position: "absolute", left: "80px", }}>
            <div className="order-route-text ta-start" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <label title={`${routes[0].checkPointName}`}>
                {routes[0].checkPointName}
                {FEATURES.showConsignorConsigneeInOrderCard && this.props.order_details && this.props.order_details?.deliveries?.length && 
                ` (${this.props.order_details?.deliveries[0]?.consignorName}) `
                }
              </label>
            </div>
            <div
              className="w3-green timeline"
              style={{ height: "50px", width: "3px" }}
            ></div>
            <div className="order-route-text ta-end" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <label style={{ width: '100%' }} title={`${routes[routes.length - 1].checkPointName}`}>
                {routes[routes.length - 1].checkPointName}
                {FEATURES.showConsignorConsigneeInOrderCard && this.props.order_details && this.props.order_details?.deliveries?.length && 
                ` (${this.props.order_details?.deliveries[0]?.consigneeName}) `
                }
              </label>
            </div>
          </div>
        </div>
      </>
    ) : (
      <MiniPlaceholder />
    );
  }
}

export default RouteManager;
